import { render, staticRenderFns } from "./TextAreaBox.vue?vue&type=template&id=ce6e726e&scoped=true&"
import script from "./TextAreaBox.vue?vue&type=script&lang=js&"
export * from "./TextAreaBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6e726e",
  null
  
)

export default component.exports